import ModelState from 'spa/state/_util/model';

class PartnerOffersState extends ModelState {
  get method() { return 'GET'; }
  get url() { return '/partner-offers'; }
  get singular() { return 'partnerOffer'; }
  get plural() { return 'partnerOffers'; }
}

export default PartnerOffersState;



// WEBPACK FOOTER //
// ./spa/state/partner-offers.jsx